import React from 'react';
import './LoginPage.css';
import SupportRequestForm from './SupportRequestForm';

const TroubleLoginPage = () => {
    return (
        <div className="login-page">
            <SupportRequestForm />
        </div>
    );
};

export default TroubleLoginPage;
